export enum TransportStopType {
	STOP_DEPARTURE = 'stopDeparture',
	STOP_RETURN = 'stopReturn',
}
